import type { SelectableAudienceType } from '@xing-com/crate-brewery-audience-selection';
import { IconPublic } from '@xing-com/icons';

export const COMMBOX_SELECTABLE_AUDIENCES: SelectableAudienceType[] = [
  {
    id: 'PUBLIC',
    Icon: IconPublic,
    audienceName: 'COMMBOX_AUDIENCE_PUBLIC',
    audienceDescription: 'COMMBOX_AUDIENCE_PUBLIC_DESC',
    visibility: 'PUBLIC',
  },
];
